// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__N1EkC","loader":"Loader_loader__oyCaa","spin":"Loader_spin__LIAAU"};